import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/UseAuth";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import { RedirectIfLoggedIn } from "./utils/RedirectIfLoggedIn";
import "./index.css"

const LoginPage = lazy(() => import("./pages/Login/Login"));
const RegisterPage = lazy(() => import("./pages/Register/Register"));
const Home = lazy(() => import("./pages/Home/Home"));
const NotFound = lazy(() => import("./utils/NotFound"));
const Test = lazy(() => import("./utils/TestProtectedPage"));

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route
          path="/login"
          element={
            <RedirectIfLoggedIn>
              <LoginPage />
            </RedirectIfLoggedIn>
          }
        />
        <Route 
          path="/register"
          element={
            <RedirectIfLoggedIn>
                <RegisterPage />
            </RedirectIfLoggedIn>
            } />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feed"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test"
          element={
            <ProtectedRoute>
              <Test />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;